// extracted by mini-css-extract-plugin
export default {"distribution":"bottomContent_distribution__N+ECX","groupRadio":"bottomContent_groupRadio__izee9","table":"bottomContent_table__Vs87A"};